import { PortalShellConfigValue } from "@/components/Layout/PortalShellConfig";

import { partnerNavigationItems } from "./partnerNavigationItems";

export const partnerShellConfig: PortalShellConfigValue = {
  homeLink: "/partner/cockpit",
  navigationItems: partnerNavigationItems,
  showCockpitTodos: false,
  showFriendsWithBenefitsBubble: false,
};
